import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMakerbotComponent } from './simple-icons-makerbot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMakerbotComponent ],
    exports:      [ SimpleIconsMakerbotComponent ],
    bootstrap:    []
})
export class SimpleIconsMakerbotModule {}
